import {ActionTypes} from "../constants/action-types";

export function setTeamData(data){
    return {
        type: ActionTypes.SET_TEAM_DATA,
        payload: data
    };
}
